import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import TIMEZONES from "../time-selector/timezones";
import {TimezoneService} from "../../Services/timezone/timezone.service";
import {Timezone} from "../../Models/Timezone";
import {ModalCloserService} from "../../modal-closer.service";
import {CalendarTodayService} from "../../Services/calendar-today/calendar-today.service";

@Component({
  selector: 'app-desktop-timezone-selector',
  templateUrl: './desktop-timezone-selector.component.html',
  styleUrls: ['./desktop-timezone-selector.component.scss']
})
export class DesktopTimezoneSelectorComponent {

  timezones = TIMEZONES;
  timezoneService: TimezoneService;
  modalCloser: ModalCloserService;
  todayService: CalendarTodayService;

  selectTimezone(timezone: Timezone) {
    window['appointmentTimezone'] = timezone.offset.substr(3, 3) + '00';
    this.todayService.currentDate = null;
    document.getElementById('reRenderTimeZone').click();
    this.timezoneService.timezone = timezone;
    this.modalCloser.closeEvents.next(timezone);
  }

  chooseTimezone(timezone) {
    window['appointmentTimezone'] = timezone.time;
    this.todayService.currentDate = null;
    document.getElementById('reRenderTimeZone').click();
    this.timezoneService.timezone = timezone;
    this.timezoneService.setZoneId();
    this.timezoneService.setRegion();
    this.modalCloser.closeEvents.next(timezone);
  }

  constructor(timezone: TimezoneService, modalCloser:ModalCloserService, today: CalendarTodayService) {
    this.timezoneService = timezone;
    this.modalCloser = modalCloser;
    this.todayService = today;
  }

}



// WEBPACK FOOTER //
// /app/src/app/Components/desktop-timezone-selector/desktop-timezone-selector.component.ts